module.exports = __webpack_public_path__ + "img/Check-circle.31f23b20.svg";